import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { PlatformRazorpayReplaceRequest, PlatformRazorpayResponse } from "@eduviaos/shared";
import { api } from "@/lib/api";

export const platformRazorpayKeys = {
  all: ["platform-razorpay"] as const,
};

export function usePlatformRazorpay() {
  return useQuery<PlatformRazorpayResponse>({
    queryKey: platformRazorpayKeys.all,
    queryFn: () => api.get<PlatformRazorpayResponse>("/super-admin/billing/razorpay"),
    staleTime: 15_000,
  });
}

export function useReplacePlatformRazorpay() {
  const qc = useQueryClient();
  return useMutation<PlatformRazorpayResponse, Error, PlatformRazorpayReplaceRequest>({
    mutationFn: (body) => api.put<PlatformRazorpayResponse>("/super-admin/billing/razorpay", body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: platformRazorpayKeys.all });
    },
  });
}
